import { Component, _decorator } from 'cc';
import Dropdown from '../../../../common/scripts/Toolkit/Components/Dropdown/Dropdown';
import LocalizedLabel from '../../../../common/scripts/Toolkit/Components/LocalizedComponent/LocalizedLabel';
import DataType from '../Data/Config/DataStructure';

const { ccclass, property, requireComponent } = _decorator;

const languageDisplayOrder: DataType.Enums.PlayType[] = [DataType.Enums.PlayType.Single, DataType.Enums.PlayType.Multiple, DataType.Enums.PlayType.Round];
const languageDisplayKeyMap: { [value in DataType.Enums.PlayType]?: string } = {
    [DataType.Enums.PlayType.Single]: '',
    [DataType.Enums.PlayType.Multiple]: '',
    [DataType.Enums.PlayType.Round]: '',
};

@ccclass('PlayTypeDropdown')
@requireComponent(Dropdown)
export default class PlayTypeDropdown extends Component {
    @property
    protected readonly singlePlayLocalizedKey = '';
    @property
    protected readonly multiplePlayLocalizedKey = '';
    @property
    protected readonly roundPlayLocalizedKey = '';

    private _dropdown: Dropdown<DataType.Enums.PlayType> = null;

    private get dropdown() {
        if (!this._dropdown) {
            this._dropdown = this.getComponent(Dropdown) as Dropdown<DataType.Enums.PlayType>;
        }
        return this._dropdown;
    }

    protected onLoad() {
        this._initializeLanguageDisplayKeyMap();
        this.dropdown.init(
            languageDisplayOrder,
            (displayName, selectedOption) => {
                displayName.getComponent(LocalizedLabel).key = languageDisplayKeyMap[selectedOption];
            },
            (node, option) => {
                node.getComponentInChildren(LocalizedLabel).key = languageDisplayKeyMap[option];
            },
        );
    }

    private _initializeLanguageDisplayKeyMap() {
        languageDisplayKeyMap[DataType.Enums.PlayType.Single] = this.singlePlayLocalizedKey;
        languageDisplayKeyMap[DataType.Enums.PlayType.Multiple] = this.multiplePlayLocalizedKey;
        languageDisplayKeyMap[DataType.Enums.PlayType.Round] = this.roundPlayLocalizedKey;
    }
}
